import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { MarketplaceBalanceState } from "../../models/mp-admin/marketplace-balance-state";

const initialState: MarketplaceBalanceState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.marketplaceBalance.getApi, (state) => ({ ...state, loading: true })),
	on(MpAdminActions.marketplaceBalance.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.marketplaceBalance.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function marketplaceBalanceReducer(
	state: MarketplaceBalanceState,
	action: Action
): MarketplaceBalanceState {
	return reducer(state, action);
}
